import { requestWithToken } from '../utilities/request';

// ファイル取得API
const files = param => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/static_files/preview',
    params: param,
    responseType: 'blob',
  });
};

// 静的ファイル最終更新日時一覧取得API
const lastModifiedTimes = () => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/static_files/last_modified_times',
  });
};

const getPresignedUrlS3 = params => {
  return requestWithToken(
    {
      method: 'GET',
      url: '/api/private/static_files/s3_presigned_url',
      params,
    },
    false
  );
};

export const StaticFileService = {
  files,
  lastModifiedTimes,
  getPresignedUrlS3,
};

export default StaticFileService;



// WEBPACK FOOTER //
// ./src/services/StaticFiles.js